import Vue from "vue";

Vue.mixin({
  methods: {
    roleEditUser(val) {
      return this.$store.getters.editRoleUser(val);
    },
    roleAdminUser(val) {
      return this.$store.getters.adminRoleUser(val);
    },
    checkValidUrl(val) {
      if (val) {
        const url = val.toLowerCase();
        if (url.indexOf("https://") == 0 || url.indexOf("http://") == 0) {
          return true;
        } else {
          return "В начале ссылки должно быть https:// или http://";
        }
      } else if (!val) {
        return true;
      }
    },
    checkValidUrlHttps(val) {
      if (val) {
        const url = val.toLowerCase();
        if (url.indexOf("https://") == 0) {
          return true;
        } else {
          return "В начале ссылки должно быть https://";
        }
      }
    },
    createDebounce() {
      let timeout = null;
      return (fnc, delayMs) => {
        clearTimeout(timeout);
        timeout = setTimeout(() => {
          fnc();
        }, delayMs || 500);
      };
    },
    phoneFormatRu(s, plus = true) {
      const startsWith = plus ? "+7" : "8";
      const phone = s
        .replace(/[^0-9]/g, "")
        .replace(/^[78]/, "")
        .replace(/^[+]/, "");

      return `${startsWith} ${phone.slice(0, 3)} ${phone.slice(
        3,
        6
      )}-${phone.slice(6, 8)}-${phone.slice(8)}`;
    },
    validatorMail(mail) {
      // const reg = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;
      if (mail) {
        const reg =
          /^(([^<>()[\]\\.,;:\s@']+(\.[^<>()\\[\]\\.,;:\s@']+)*)|('.+'))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        if (reg.test(mail) == false) {
          return false;
        } else {
          return true;
        }
      } else {
        return true;
      }
    },
  },
});
